export const roundUpToNearest = (amount: number, near: number) => Math.ceil(Number(amount) / near) * near

export const sortItemsWithOtherLast = (localeA: string, localeB: string) => {
  if (localeA.toLowerCase().includes('other') || localeA.includes('其他')) return 1
  if (localeB.toLowerCase().includes('other') || localeB.includes('其他')) return -1
  return 0
}
